import { j as e } from "./atoms-v218.js";
import { forwardRef as Q, useRef as W, useState as X, useCallback as p, useImperativeHandle as Y, useEffect as D, useMemo as E, cloneElement as I, Children as Z, isValidElement as _ } from "react";
import { useFloating as T, useDismiss as ee, useInteractions as re, FloatingFocusManager as te } from "./atoms-v280.js";
import { Footer as se } from "./atoms-v281.js";
import { Icon as oe } from "./atoms-v217.js";
import { AnchoredDialog as ne, Header as le, HeaderLeft as ae, HeaderLabel as ie, Heading as ce, Close as ue, CloseButton as de, Body as fe } from "./atoms-v282.js";
import { flip as me, shift as pe, autoUpdate as he } from "./atoms-v283.js";
import { offset as ge } from "./atoms-v284.js";
const O = Q(
  ({
    anchorElement: h,
    cancelText: g = "Cancel",
    children: k,
    className: v,
    colorTheme: j = "light",
    confirmText: x = "Confirm",
    dismissOnClickOutside: w = !0,
    dismissOnESC: M = !0,
    dismissOnScroll: P = !1,
    footer: a,
    headerLabel: y,
    id: r,
    isDismissable: s = !0,
    isFlippable: S = !0,
    isOpen: F = !1,
    isShiftable: V = !0,
    offset: C,
    onCancel: i,
    onClose: c,
    onConfirm: o,
    onToggle: u,
    placement: z = "bottom-end",
    size: A = "default",
    strategy: B = "absolute",
    title: L
  }, N) => {
    const d = W(!0), [t, n] = X(F ?? !1), { context: R, floatingStyles: K, refs: f } = T({
      middleware: [
        ...S ? [me()] : [],
        ...C ? [ge(C)] : [],
        ...V ? [pe()] : []
      ],
      onOpenChange: n,
      open: t,
      placement: z,
      strategy: B,
      whileElementsMounted: he
    }), U = ee(R, {
      ancestorScroll: P,
      enabled: s,
      escapeKey: M,
      outsidePress: w
    }), { getFloatingProps: q, getReferenceProps: $ } = re([U]), b = p(() => {
      o == null || o(r);
    }, [r, o]), m = p(() => {
      n(!1), c && c(r);
    }, [r, c]), H = p(() => {
      n(!1), i && i(r);
    }, [r, i]);
    Y(
      N,
      () => ({
        close() {
          m();
        }
      }),
      [m]
    ), D(() => {
      !d.current && u && u(t);
    }, [t, u]), D(() => {
      if (d.current) {
        d.current = !1;
        return;
      }
    }, []);
    const G = E(() => I(h, {
      onClick: () => n(!t),
      ref: f.setReference,
      ...$()
    }), [h, $, t, f.setReference]), J = E(() => a ? Z.map(a, (l) => typeof l.type != "string" && _(l) ? I(
      l,
      {
        cancelText: g,
        confirmText: x,
        isDismissable: s,
        onCancel: H,
        onConfirm: b
      }
    ) : l) : null, [g, x, a, H, b, s]);
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      G,
      t ? /* @__PURE__ */ e.jsx(te, { context: R, children: /* @__PURE__ */ e.jsxs(
        ne,
        {
          $colorTheme: j,
          $size: A,
          "aria-labelledby": `${r}-title`,
          "aria-modal": "true",
          className: v,
          id: r,
          ref: f.setFloating,
          role: "dialog",
          style: K,
          ...q(),
          children: [
            /* @__PURE__ */ e.jsxs(le, { children: [
              /* @__PURE__ */ e.jsxs(ae, { children: [
                y && /* @__PURE__ */ e.jsx(ie, { $colorTheme: j, children: y }),
                /* @__PURE__ */ e.jsx(ce, { $size: A, "aria-level": 3, id: `${r}-title`, role: "heading", children: L })
              ] }),
              s ? /* @__PURE__ */ e.jsx(ue, { children: /* @__PURE__ */ e.jsx(
                de,
                {
                  iconOnly: !0,
                  ariaLabel: "Close dialog",
                  onClick: m,
                  variant: "ghost",
                  children: /* @__PURE__ */ e.jsx(oe, { name: "close--large", size: "small" })
                }
              ) }) : null
            ] }),
            /* @__PURE__ */ e.jsx(fe, { children: k }),
            J
          ]
        }
      ) }) : null
    ] });
  }
);
O.displayName = "AnchoredDialog";
const De = Object.assign(O, { Footer: se });
export {
  De as AnchoredDialog
};
